import SectionHeading from "@/components/base/SectionHeading";
import VoicesGrid from "@/components/feature/VoicesGrid";

export default function VoicesSection() {
  return (
    <section id="voices" className="bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="读者口碑"
          title="他们这样围观"
          desc="来自长期蹲守在这里的读者反馈。我们更在意的是，大家看完之后是不是真的更明白了一点。"
        />
        <div className="mt-8">
          <VoicesGrid />
        </div>
      </div>
    </section>
  );
}